import type { JSX } from 'react'
import { Textbit } from '@ttab/textbit'
import { cn } from '@ttab/elephant-ui/utils'
import type { AcceptedSpelling } from '@/hooks/useAcceptedSpelling'
import { ContextMenu } from '../../Editor/ContextMenu'

export const TextboxEditable = ({ singleLine, autoFocus, onFocus, onBlur, acceptedSpelling }: {
  singleLine: boolean
  spellcheck?: boolean
  autoFocus?: boolean | 'start' | 'end'
  onBlur: React.FocusEventHandler<HTMLDivElement>
  onFocus: React.FocusEventHandler<HTMLDivElement>
  /**
   * Lets a word be accepted from this field, as `useAcceptedSpelling` returns
   * it. Passed only where the document's schema declares the block, which is
   * the caller's to know: a planning field spellchecks like any other, and
   * accepting there would write something the repository refuses.
   */
  acceptedSpelling?: AcceptedSpelling
}): JSX.Element | undefined => {
  return (
    <Textbit.Editable
      constraints={{ allowEdgeWhitespace: false }}
      autoFocus={autoFocus}
      onBlur={onBlur}
      onFocus={onFocus}
      isSpellingAccepted={acceptedSpelling?.isAccepted}
      className={cn(!singleLine && 'min-h-20!',
        `p-1
        py-1.5
        ps-2
        rounded-md
        outline-none
        ring-offset-background
        focus:ring-1
        ring-input
        focus:dark:ring-gray-600
        whitespace-nowrap`
      )}
    >
      <ContextMenu
        className='z-9999'
        onAccept={acceptedSpelling?.accept}
        onRemoveAccepted={acceptedSpelling?.remove}
      />
    </Textbit.Editable>
  )
}
